import initialState from "./initialState"
import { reducer as fetchAllLgReducer } from "./fetchAllLg"
import { reducer as fetchLgDetailReducer } from "./fetchLgDetail"
import { reducer as updateCurrentLocationReducer } from "./updateCurrentLocation"
import { reducer as updateMapPropsReducer } from "./updateMapProps"
import { AUTH_LOGOUT } from "../../auth/redux/constants"

const reducers = [fetchAllLgReducer, fetchLgDetailReducer, updateCurrentLocationReducer, updateMapPropsReducer]

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    // Handle cross-topic actions here
    case AUTH_LOGOUT:
      newState = initialState // clear sensitive data
      break
    default:
      newState = state
      break
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState)
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js